<template>
  <v-card>
    <v-app-bar flat>
      <v-text-field
        label="Search order..."
        append-icon="search"
        v-model="query.search"
        clearable
        hide-details
      ></v-text-field>

      <v-btn icon @click="getData()"> <v-icon>refresh</v-icon> </v-btn>
      <v-btn icon @click="showDialogDownload()">
        <v-icon>get_app</v-icon>
      </v-btn>
      <v-btn icon @click="expand = !expand" v-if="!expand">
        <v-icon>filter_list</v-icon>
      </v-btn>
      <v-btn icon @click="expand = !expand" v-if="expand">
        <v-icon>keyboard_arrow_up</v-icon>
      </v-btn>
    </v-app-bar>
    <v-expand-transition>
      <div v-if="expand">
        <v-container fluid grid-list-xl>
          <v-layout wrap align-center>
            <v-flex xs12 sm3 d-flex>
              <v-select
                v-model="status"
                :items="statusOptions"
                item-text="label"
                item-value="value"
                :label="$t('filter.byStatus')"
                clearable
              ></v-select>
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-menu
                ref="menuStart"
                v-model="menuStart"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="startDateFormatted"
                  label="Start Date"
                  hint="DD/MM/YYYY"
                  persistent-hint
                  clearable
                  prepend-icon="event"
                  @blur="startDate = parseDate(startDateFormatted)"
                ></v-text-field>
                <v-date-picker
                  v-model="startDate"
                  no-title
                  @input="menuStart = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm3 md3>
              <v-menu
                ref="menuEnd"
                v-model="menuEnd"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <v-text-field
                  slot="activator"
                  v-model="endDateFormatted"
                  label="End Date"
                  hint="DD/MM/YYYY"
                  persistent-hint
                  prepend-icon="event"
                  clearable
                  @blur="endDate = parseDate(endDateFormatted)"
                ></v-text-field>
                <v-date-picker
                  v-model="endDate"
                  no-title
                  @input="menuEnd = false"
                ></v-date-picker>
              </v-menu>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </v-expand-transition>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        dense
        :headers="headers"
        :items="listOrders"
        item-key="id"
        :options.sync="pagination"
        :server-items-length="totalOrders"
        :loading="loading"
        :footer-props="footerOptions"
      >
        <template v-slot:item.order_no="{ item }">
          {{ item.order_id }}
        </template>

        <template v-slot:item.price_amount="{ item }">
          {{ item.price_amount }}
          {{ item.price_currency ? item.price_currency : "" }}
        </template>
        <template v-slot:item.pay_amount="{ item }">
          {{ item.pay_amount }} {{ item.pay_currency ? item.pay_currency : "" }}
        </template>
        <template v-slot:item.network="{ item }">
          <v-chip
              v-if="item.network"
              label
              small
              outlined
              :color="getColorByNetwork(item.network)"
          >
            {{
              item.network === "trx"
                  ? "TRC20"
                  : item.network === "eth"
                      ? "ERC20"
                      : ""
            }}
          </v-chip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip label small outlined :color="getColorByStatus(item.status)"
            >{{ item.status | uppercase }}
          </v-chip>
        </template>

        <template v-slot:item.received_amount="{ item }">
          {{
            item.received_amount
              ? item.received_amount + " " + item.pay_currency
              : "_"
          }}
        </template>

        <template v-slot:item.created_at="{ item }">
          {{ item.created_at | moment("YYYY-MM-DD HH:mm:ss") }}
        </template>

        <template v-slot:item.updated_at="{ item }">
          {{ item.updated_at | moment("YYYY-MM-DD HH:mm:ss") }}
        </template>

        <template v-slot:item.viewAction="{ item }">
          <v-btn outlined small color="indigo" @click="showItem(item)">
            Detail
          </v-btn>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>

    <order-dialog
      :dialog="dialog"
      :selectedItem="selectedItem"
      :getColorByStatus="getColorByStatus"
      :showDateTime="showDateTime"
      :close="close"
      :checkBalance="checkBalance"
      :markPaid="showConfirmCheckPaid"
    ></order-dialog>

    <v-dialog v-model="dialogExport" persistent max-width="350px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("dialog.export.selectFormat") }}</span>
        </v-card-title>
        <v-card-text>
          <v-radio-group v-model="bookType">
            <v-radio
              v-for="n in ['xlsx', 'csv']"
              :key="n"
              :label="`Format .${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogExport = false">{{
            $t("button.close")
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="handleDownload()"
            >Export</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <confirm-dialog :confirmDialog="confirmDialog"></confirm-dialog>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import OrderDialog from "@/components/dialog/OrderDialog.vue";
import ConfirmDialog from "@/components/dialog/ConfirmDialog.vue";
import Util from "@/util";
import {getColorByNetwork} from "../../../util/cryptoCurrencies";

export default {
  name: "PlainTableOrder",
  components: {
    OrderDialog,
    ConfirmDialog
  },
  data(self) {
    return {
      expand: false,
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 20,
        sortBy: ["created_at"],
        sortDesc: [true]
      },
      footerOptions: {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 10, 15, 20, 25, 30]
      },
      headers: [
        {
          text: "#",
          align: "left",
          value: "id",
          width: "100"
        },
        { text: self.$t("table.order.title"), value: "title", width: "200" },
        {
          text: self.$t("table.order.merchantOrderID"),
          value: "order_no",
          width: "200"
        },
        {
          text: self.$t("table.order.price"),
          value: "price_amount",
          align: "end",
          width: "150"
        },
        {
          text: self.$t("table.order.payAmount"),
          value: "pay_amount",
          align: "end",
          width: "150"
        },
        { text: "Network", value: "network", sortable: false },
        { text: self.$t("common.status"), value: "status", width: "150" },
        {
          text: self.$t("table.withdrawal.receivedAmount"),
          value: "received_amount",
          align: "end",
          width: "150"
        },
        {
          text: self.$t("common.createdAt"),
          value: "created_at",
          width: "220"
        },
        {
          text: self.$t("common.updatedAt"),
          value: "updated_at",
          width: "220"
        },
        {
          text: self.$t("table.order.appName"),
          value: "app_title",
          width: "200",
          sortable: false
        },
        { text: "", value: "viewAction" }
      ],
      dialog: false,
      selectedItem: null,
      itemId: null,
      statusOptions: [
        {
          value: "tx_without_paid",
          label: "Tx without Paid"
        },
        {
          value: "unconfirmed",
          label: "Unconfirmed"
        },
        {
          value: "paid",
          label: "Paid"
        },
        {
          value: "pending",
          label: "Pending"
        },
        {
          value: "expired",
          label: "Expired"
        },
        {
          value: "illegal",
          label: "Illegal"
        },
        {
          value: "fraud",
          label: "Fraud"
        }
      ],
      status: "",
      snackbar: {
        show: false,
        text: "",
        color: ""
      },
      confirmDialog: {
        dialog: false,
        title: self.$t("dialog.order.titleChangePaid"),
        message: self.$t("dialog.order.confirmUpdate"),
        cancelTitle: self.$t("button.disagree"),
        okTitle: self.$t("button.agree"),
        success: self.markPaid
      },
      filename: "Orders",
      endDateFormatted: null,
      startDateFormatted: null,
      startDate: null,
      endDate: null,
      menuStart: false,
      menuEnd: false,
      exportData: null,
      dialogExport: false,
      bookType: "csv",
      query: {
        search: "",
        app: ""
      },
      oldSearch: ""
    };
  },
  computed: {
    ...mapGetters(["listOrders", "totalOrders", "listApps", "selectedApp"])
  },
  methods: {
    getColorByNetwork,
    getColorByStatus(status) {
      return Util.getColorByStatus(status);
    },
    getData(exportOption) {
      let orderParam = "";
      if (this.pagination.sortBy) {
        if (this.pagination.sortBy && this.pagination.sortBy[0]) {
          orderParam = this.pagination.sortBy[0];

          if (this.pagination.sortDesc[0]) {
            orderParam = "-" + orderParam;
          }
        }
      }

      this.loading = true;
      if (this.oldSearch !== this.query.search) {
        this.pagination.page = 0;
        this.oldSearch = this.query.search;
      }
      return this.$store
        .dispatch("fetchListOrder", {
          page: this.pagination.page,
          per_page: this.pagination.itemsPerPage,
          order: orderParam,
          status: this.status,
          start_date: this.startDate,
          end_date: this.endDate,
          export: exportOption,
          search: this.query.search,
          app: this.selectedApp
        })
        .then(data => {
          this.exportData = data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    showItem(item) {
      this.dialog = true;
      this.selectedItem = JSON.parse(JSON.stringify(item));
      this.itemId = item.id;
    },
    updateSelectedItem() {
      if (!this.itemId) {
        return null;
      }
      let items = this.listOrders;
      let item;
      for (let i = 0, l = items.length; i <= l; i++) {
        item = items[i];
        if (item.id === this.itemId) {
          this.selectedItem = JSON.parse(JSON.stringify(item));
          return item;
        }
      }
    },
    showDateTime(item, key) {
      if (item && item[key]) {
        return this.$moment(item[key]).format("YYYY-MM-DD HH:mm:ss");
      } else {
        return "";
      }
    },
    close() {
      this.dialog = false;
      this.selectedItem = null;
    },
    showConfirmCheckPaid() {
      this.confirmDialog.dialog = true;
    },
    markPaid() {
      this.$store
        .dispatch("markPaidOrder", this.selectedItem.id)
        .then(() => {
          this.getData().then(() => {
            this.updateSelectedItem();
          });
          this.snackbar = {
            show: true,
            color: "green",
            text: "Successfully."
          };
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            color: "red",
            text: error.response.data.error
          };
        });
    },
    checkBalance() {
      this.$store
        .dispatch("checkBalanceOrder", this.selectedItem.id)
        .then(() => {
          this.getData().then(() => {
            this.updateSelectedItem();
          });
          this.snackbar = {
            show: true,
            color: "green",
            text: "Successfully."
          };
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            color: "red",
            text: error.response.data.error
          };
        });
    },
    showDialogDownload() {
      this.dialogExport = true;
    },
    handleDownload() {
      window.getApp.$emit("SHOW_LOADING");
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "Id",
          this.$t("table.order.merchantOrderID"),
          this.$t("table.order.title"),
          "Description",
          this.$t("table.order.appName"),
          this.$t("table.order.price"),
          "Price currency",
          this.$t("table.order.payAmount"),
          "Pay currency",
          "Exchange rate",
          this.$t("table.withdrawal.receivedAmount"),
          this.$t("common.status"),
          this.$t("common.createdAt"),
          this.$t("common.updatedAt"),
          this.$t("table.withdrawal.receivedWallet"),
          "Transaction hash"
        ];
        const filterVal = [
          "id",
          "order_id",
          "title",
          "description",
          "app_title",
          "price_amount",
          "price_currency",
          "pay_amount",
          "pay_currency",
          "locked_rate",
          "received_amount",
          "status",
          "created_at",
          "updated_at",
          "tracking_address",
          "transactions"
        ];
        this.getData(true).then(() => {
          const list = this.exportData;
          const data = this.formatJson(filterVal, list);
          excel.export_json_to_excel({
            header: tHeader,
            data,
            filename: this.filename,
            autoWidth: this.autoWidth,
            bookType: this.bookType
          });
          window.getApp.$emit("HIDE_LOADING");
          this.dialogExport = false;
        });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "transactions") {
            let transactions = v[j];
            let txs = [];
            transactions.forEach(tx => {
              txs.push(tx["hash"])
            })
            return txs.join(" - ");
          } else if (j === "created_at") {
            return this.$moment(v[j]).format("YYYY-MM-DD HH:mm:ss");
            // return new Date(v[j]);
          } else if (j === "updated_at") {
            return this.$moment(v[j]).format("YYYY-MM-DD HH:mm:ss");
            // return new Date(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  mounted() {
    this.getData();
    this.$store
      .dispatch("fetchListApp")
      .then(() => {})
      .catch(() => {});
    let self = this;
    this.$root.$on("SELECTED_APP_IS_CHANGED", () => {
      self.getData();
    });
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true
    },
    status: {
      handler() {
        this.getData();
      },
      deep: true
    },
    startDate() {
      this.startDateFormatted = this.formatDate(this.startDate);
      this.getData();
    },
    endDate() {
      this.endDateFormatted = this.formatDate(this.endDate);
      this.getData();
    },
    query: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
</script>
